module.exports = __webpack_public_path__ + "img/Icon=iOS.27904d93.svg";